import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import ShareIcon from "../../images/share-icon.svg";

// Audience-first sharing (members / everyone / stop syndicating) only makes
// sense on BLS tenants, where a listing can be members-only. On gitcha.com
// every listing is public, so the owner keeps the original one-click share.

export const ShareIconButton = ({ isBlsTenant, onShare }) => {
  if (isBlsTenant) return null;
  return (
    <a role="button" className="social-content-btn mr-12" onClick={onShare}>
      <img src={ShareIcon} alt="Share" />
    </a>
  );
};

export const ShareMenuItems = ({
  isBlsTenant,
  isSyndicated,
  onShareMembers,
  onShareEveryone,
  onStopSyndicating,
}) => {
  if (!isBlsTenant) return null;
  return (
    <>
      <Dropdown.Item onClick={onShareMembers}>Share with members</Dropdown.Item>
      <Dropdown.Item onClick={onShareEveryone}>
        Share with everyone
      </Dropdown.Item>
      {isSyndicated && (
        <Dropdown.Item onClick={onStopSyndicating}>
          Stop syndicating
        </Dropdown.Item>
      )}
      <Dropdown.Divider />
    </>
  );
};
